module.exports = __webpack_public_path__ + "media/badges/badge--yellow-20ef9647.svg";